import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    const formData = new FormData(form);
    const url = 'https://readdy.ai/api/form/d918bgo4jh3v1cgksso0';
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        body.append(key, value.toString());
      }
    });

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then(() => setSubmitted(true))
      .catch(() => setSubmitted(true));
  };

  if (submitted) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-28 pb-20 px-4 md:px-6 flex items-center justify-center">
          <div className="text-center max-w-md">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-check-line text-3xl text-primary-500"></i>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">消息已发送！</h1>
            <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
              感谢你的留言！我们的团队将在1-2个工作日内通过邮件回复你。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </div>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-28 pb-16 px-4 md:px-6 bg-background-100">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs text-foreground-500 tracking-widest uppercase mb-4">联系我们</p>
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-4">我们期待与你交流</h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              无论你是对课程感兴趣，还是有合作意向，或是有任何建议——欢迎随时联系我们
            </p>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <div className="mx-auto max-w-6xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              {/* Form */}
              <div>
                <form data-readdy-form="" onSubmit={handleSubmit} className="bg-background-100 rounded-2xl p-6 md:p-8">
                  <h2 className="font-heading text-xl text-foreground-950 mb-6">发送消息</h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="name" className="block text-xs text-foreground-600 mb-1.5">姓名 <span className="text-red-500">*</span></label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="你的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-xs text-foreground-600 mb-1.5">邮箱 <span className="text-red-500">*</span></label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="subject" className="block text-xs text-foreground-600 mb-1.5">主题 <span className="text-red-500">*</span></label>
                    <select
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer appearance-none"
                      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10z'/%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', paddingRight: '2.5rem' }}
                    >
                      <option value="">请选择主题</option>
                      <option value="课程咨询">课程咨询</option>
                      <option value="企业合作">企业合作</option>
                      <option value="退款相关">退款相关</option>
                      <option value="技术支持">技术支持</option>
                      <option value="其他问题">其他问题</option>
                    </select>
                  </div>

                  <div className="mb-6">
                    <label htmlFor="message" className="block text-xs text-foreground-600 mb-1.5">消息内容 <span className="text-red-500">*</span></label>
                    <textarea
                      id="message"
                      name="message"
                      rows={5}
                      maxLength={500}
                      required
                      className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请详细描述你的问题或需求..."
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                  </div>

                  {/* Anti-spam honeypot */}
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" className="absolute opacity-0 pointer-events-none" />

                  <button
                    type="submit"
                    className="w-full py-3.5 bg-foreground-900 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap text-sm"
                  >
                    发送消息
                  </button>
                </form>
              </div>

              {/* Info */}
              <div>
                <h2 className="font-heading text-xl text-foreground-950 mb-8">联系方式</h2>

                <div className="space-y-5 mb-10">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">admin@bbgpt.online</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-phone-line text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">联系电话</h3>
                      <p className="text-sm text-foreground-600">400-888-AI学习 (400-888-2499)</p>
                      <p className="text-sm text-foreground-600">+86 18824603638</p>
                      <p className="text-xs text-foreground-400 mt-1">工作时间：周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">办公地址</h3>
                      <p className="text-sm text-foreground-600">海南省海口市美兰区新埠街道新埠岛新埠路9号</p>
                      <p className="text-sm text-foreground-600">海南自贸港跨境电商产业园主楼北侧三层东区301-22</p>
                    </div>
                  </div>
                </div>

                {/* Map */}
                <div className="rounded-2xl overflow-hidden bg-background-100">
                  <iframe
                    title="bbgpt.online 办公地址"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14843.455555148658!2d110.345000!3d20.030000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31520b6b0b0b0b0b%3A0x7b0b7b0b7b0b7b0b!2sMeilan%2C+Haikou%2C+Hainan!5e0!3m2!1sen!2sus!4v1700000000000"
                    width="100%"
                    height="240"
                    style={{ border: 0 }}
                    allowFullScreen={false}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* Social */}
                <div className="mt-8">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h3>
                  <div className="flex items-center gap-3">
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-foreground-900 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信公众号" rel="nofollow">
                      <i className="ri-wechat-line text-lg"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-foreground-900 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                      <i className="ri-weibo-line text-lg"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-foreground-900 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
                      <i className="ri-bilibili-line text-lg"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:bg-foreground-900 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书" rel="nofollow">
                      <i className="ri-article-line text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}